/*
  Price range slider behaviour for Shopify Dawn
  Drop into: assets/price-slider.js  (loaded with defer)

  - Handles are <button> elements (not inputs) so Dawn's PriceRange element,
    which does querySelectorAll('input'), keeps working unchanged.
  - Initial positions are rendered server-side in Liquid, so this script only
    needs delegated pointer/keyboard handling and survives Dawn's AJAX re-render.
  - On release it writes a plain number to Dawn's min/max inputs and dispatches
    `change` (PriceRange validation) + `input` (Dawn's debounced auto-submit).
*/
(function () {
  'use strict';

  function parseNum(v) {
    if (v == null) return NaN;
    return parseFloat(String(v).replace(/[^0-9.\-]/g, ''));
  }

  function clamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
  }

  function getCtx(slider) {
    var priceRange = slider.closest('price-range') || slider.parentElement;
    return {
      track: slider.querySelector('.price-slider__track'),
      progress: slider.querySelector('.price-slider__progress'),
      minHandle: slider.querySelector('.price-slider__handle--min'),
      maxHandle: slider.querySelector('.price-slider__handle--max'),
      minInput: priceRange ? priceRange.querySelector('input[id$="-GTE"]') : null,
      maxInput: priceRange ? priceRange.querySelector('input[id$="-LTE"]') : null,
      maxUnits: parseNum(slider.dataset.max) || 0
    };
  }

  function pctFromValue(val, maxUnits) {
    if (!maxUnits) return 0;
    return clamp((val / maxUnits) * 100, 0, 100);
  }

  function valueFromPct(pct, maxUnits) {
    return Math.round((pct / 100) * maxUnits);
  }

  function currentPcts(ctx) {
    var minVal = parseNum(ctx.minInput && ctx.minInput.value);
    var maxVal = parseNum(ctx.maxInput && ctx.maxInput.value);
    if (isNaN(minVal)) minVal = 0;
    if (isNaN(maxVal)) maxVal = ctx.maxUnits;
    return {
      min: pctFromValue(minVal, ctx.maxUnits),
      max: pctFromValue(maxVal, ctx.maxUnits)
    };
  }

  function render(ctx, minPct, maxPct) {
    if (ctx.minHandle) ctx.minHandle.style.left = minPct + '%';
    if (ctx.maxHandle) ctx.maxHandle.style.left = maxPct + '%';
    if (ctx.progress) {
      ctx.progress.style.left = minPct + '%';
      ctx.progress.style.width = (maxPct - minPct) + '%';
    }
    if (ctx.minHandle) ctx.minHandle.setAttribute('aria-valuenow', valueFromPct(minPct, ctx.maxUnits));
    if (ctx.maxHandle) ctx.maxHandle.setAttribute('aria-valuenow', valueFromPct(maxPct, ctx.maxUnits));
  }

  function fire(input) {
    if (!input) return;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.dispatchEvent(new Event('input', { bubbles: true }));
  }

  function pointToPct(ctx, clientX) {
    var rect = ctx.track.getBoundingClientRect();
    if (!rect.width) return 0;
    return clamp(((clientX - rect.left) / rect.width) * 100, 0, 100);
  }

  var drag = null;

  document.addEventListener('pointerdown', function (e) {
    var handle = e.target.closest && e.target.closest('.price-slider__handle');
    if (!handle) return;
    var slider = handle.closest('.price-slider');
    if (!slider) return;
    e.preventDefault();
    drag = { ctx: getCtx(slider), type: handle.dataset.handle };
    try { handle.setPointerCapture(e.pointerId); } catch (err) {}
    document.documentElement.classList.add('price-slider-active');
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag) return;
    var ctx = drag.ctx;
    var pct = pointToPct(ctx, e.clientX);
    var pcts = currentPcts(ctx);

    if (drag.type === 'min') {
      pct = Math.min(pct, pcts.max);
      pcts.min = pct;
      if (ctx.minInput) ctx.minInput.value = valueFromPct(pct, ctx.maxUnits);
    } else {
      pct = Math.max(pct, pcts.min);
      pcts.max = pct;
      if (ctx.maxInput) ctx.maxInput.value = valueFromPct(pct, ctx.maxUnits);
    }
    render(ctx, pcts.min, pcts.max);
  });

  function endDrag() {
    if (!drag) return;
    var input = drag.type === 'min' ? drag.ctx.minInput : drag.ctx.maxInput;
    fire(input);
    drag = null;
    document.documentElement.classList.remove('price-slider-active');
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  // Keyboard nudging (arrow keys; Shift = bigger step)
  document.addEventListener('keydown', function (e) {
    var handle = e.target.closest && e.target.closest('.price-slider__handle');
    if (!handle) return;
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    e.preventDefault();

    var ctx = getCtx(handle.closest('.price-slider'));
    var pcts = currentPcts(ctx);
    var step = (e.shiftKey ? 5 : 1) * (e.key === 'ArrowRight' ? 1 : -1);

    if (handle.dataset.handle === 'min') {
      pcts.min = clamp(pcts.min + step, 0, pcts.max);
      if (ctx.minInput) ctx.minInput.value = valueFromPct(pcts.min, ctx.maxUnits);
      render(ctx, pcts.min, pcts.max);
      fire(ctx.minInput);
    } else {
      pcts.max = clamp(pcts.max + step, pcts.min, 100);
      if (ctx.maxInput) ctx.maxInput.value = valueFromPct(pcts.max, ctx.maxUnits);
      render(ctx, pcts.min, pcts.max);
      fire(ctx.maxInput);
    }
  });

  // Keep handles in sync when a shopper types directly in a box
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.price-slider__values input')) return;
    var slider = input.closest('.price-slider');
    if (!slider) return;
    var ctx = getCtx(slider);
    var pcts = currentPcts(ctx);
    render(ctx, pcts.min, pcts.max);
  });
})();
